import { render, staticRenderFns } from "./PhpSettingsModal.vue?vue&type=template&id=498a4ce6&scoped=true"
import script from "./PhpSettingsModal.vue?vue&type=script&lang=js"
export * from "./PhpSettingsModal.vue?vue&type=script&lang=js"
import style0 from "../../../../components/modal/BasicModal.scss?vue&type=style&index=0&id=498a4ce6&prod&lang=scss&scoped=true&external"
import style1 from "./PhpSettingsModal.vue?vue&type=style&index=1&id=498a4ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a4ce6",
  null
  
)

export default component.exports